(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7936],{

/***/ 32924:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var blocks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));

});

unwrapExports(blocks);
var blocks_1 = blocks.BLOCKS;

var inlines = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));

});

unwrapExports(inlines);
var inlines_1 = inlines.INLINES;

var marks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
})(MARKS || (MARKS = {}));
exports.default = MARKS;

});

unwrapExports(marks);

var schemaConstraints = createCommonjsModule(function (module, exports) {
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;


/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    blocks.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
];
exports.TABLE_BLOCKS = [
    blocks.BLOCKS.TABLE,
    blocks.BLOCKS.TABLE_ROW,
    blocks.BLOCKS.TABLE_CELL,
    blocks.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [blocks.BLOCKS.HR, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks.BLOCKS.OL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.UL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks.BLOCKS.QUOTE] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE] = [blocks.BLOCKS.TABLE_ROW],
    _a[blocks.BLOCKS.TABLE_ROW] = [blocks.BLOCKS.TABLE_CELL, blocks.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks.BLOCKS.TABLE_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE_HEADER_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks.BLOCKS.DOCUMENT,
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.LIST_ITEM,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    inlines.INLINES.HYPERLINK,
    inlines.INLINES.ENTRY_HYPERLINK,
    inlines.INLINES.ASSET_HYPERLINK,
    inlines.INLINES.EMBEDDED_ENTRY,
    'text',
];

});

unwrapExports(schemaConstraints);
var schemaConstraints_1 = schemaConstraints.V1_NODE_TYPES;
var schemaConstraints_2 = schemaConstraints.TEXT_CONTAINERS;
var schemaConstraints_3 = schemaConstraints.HEADINGS;
var schemaConstraints_4 = schemaConstraints.CONTAINERS;
var schemaConstraints_5 = schemaConstraints.VOID_BLOCKS;
var schemaConstraints_6 = schemaConstraints.TABLE_BLOCKS;
var schemaConstraints_7 = schemaConstraints.LIST_ITEM_BLOCKS;
var schemaConstraints_8 = schemaConstraints.TOP_LEVEL_BLOCKS;

var types = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(types);

var nodeTypes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(nodeTypes);

var emptyDocument = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports.default = EMPTY_DOCUMENT;

});

unwrapExports(emptyDocument);

var helpers = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isText = exports.isBlock = exports.isInline = void 0;


/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;

});

unwrapExports(helpers);
var helpers_1 = helpers.isText;
var helpers_2 = helpers.isBlock;
var helpers_3 = helpers.isInline;

var dist = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;

Object.defineProperty(exports, "BLOCKS", { enumerable: true, get: function () { return blocks.BLOCKS; } });

Object.defineProperty(exports, "INLINES", { enumerable: true, get: function () { return inlines.INLINES; } });

Object.defineProperty(exports, "MARKS", { enumerable: true, get: function () { return __importDefault(marks).default; } });
__exportStar(schemaConstraints, exports);
__exportStar(types, exports);
__exportStar(nodeTypes, exports);

Object.defineProperty(exports, "EMPTY_DOCUMENT", { enumerable: true, get: function () { return __importDefault(emptyDocument).default; } });
var helpers$1 = __importStar(helpers);
exports.helpers = helpers$1;

});

unwrapExports(dist);
var dist_1 = dist.helpers;
var dist_2 = dist.EMPTY_DOCUMENT;
var dist_3 = dist.MARKS;
var dist_4 = dist.INLINES;
var dist_5 = dist.BLOCKS;

/**
 * Returns the text value of a rich text document.
 *
 * NB: This can be applied to non text node of a structured text document,
 * hence the flexible typing.
 */
function documentToPlainTextString(rootNode, blockDivisor) {
    if (blockDivisor === void 0) { blockDivisor = ' '; }
    if (!rootNode || !rootNode.content) {
        /**
         * Handles edge cases, such as when the value is not set in the CMA or the
         * field has not been properly validated, e.g. because of a user extension.
         * Note that we are nevertheless strictly type-casting `rootNode` as
         * Block | Inline. Valid rich text documents (and their branch block nodes)
         * should never lack a Node[] `content` property.
         */
        return '';
    }
    /**
     * Algorithm notes: We only want to apply spacing when a node is part of a
     * sequence. This is tricky because nodes can often be deeply nested within
     * non-semantic content arrays. For example, to get the text value of an
     * unordered list, we have to traverse like so:
     *
     * {
     *   nodeType: BLOCKS.UL_LIST,
     *   data: {},
     *   content: [
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'List ', marks: [] },
     *           { nodeType: 'text', data: {}, value: 'item', marks: [{ type: 'bold' }] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.HR,
     *         data: {},
     *         content: [],
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data:
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Yet another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *   }]
     * }
     *
     * We want there to be a space between 'List item' and 'Another list item' (to
     * denote a visual line break, which conventionally appears between non-text
     * node sequences) but not a redundant space between 'List ' and 'item'.
     * Moreover, we want just a _singular_ space between 'Another list item' and
     * 'Yet another list item' - the non-semantic HR between the two nodes should
     * not denote an additional space.
     */
    return rootNode.content.reduce(function (acc, node, i) {
        var nodeTextValue;
        if (dist_1.isText(node)) {
            nodeTextValue = node.value;
        }
        else if (dist_1.isBlock(node) || dist_1.isInline(node)) {
            nodeTextValue = documentToPlainTextString(node, blockDivisor);
            if (!nodeTextValue.length) {
                return acc;
            }
        }
        var nextNode = rootNode.content[i + 1];
        var isNextNodeBlock = nextNode && dist_1.isBlock(nextNode);
        var divisor = isNextNodeBlock ? blockDivisor : '';
        return acc + nodeTextValue + divisor;
    }, '');
}

__webpack_unused_export__ = documentToPlainTextString;
//# sourceMappingURL=rich-text-plain-text-renderer.es5.js.map


/***/ }),

/***/ 37710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_cinderblocks_growth_auth_LocalizationContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24773);
/* harmony import */ var _opendoor_cinderblocks_platform_auth_AccountForm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21335);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74593);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var helpers_useLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37680);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67945);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35480);
/* harmony import */ var _shared_AccountConnector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45949);














var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var UNAUTHORIZED_STATUS_CODE = 401;
var AccountFormPage = function(param) {
    var logIn = param.logIn, register = param.register, requestHumanStatus = param.requestHumanStatus, hasGeneratedPassword = param.hasGeneratedPassword, _isNewHuman = param.isNewHuman, isNewHuman = _isNewHuman === void 0 ? false : _isNewHuman, loginRequestStatus = param.loginRequestStatus, humanStatusRequestStatus = param.humanStatusRequestStatus, registrationRequestStatus = param.registrationRequestStatus, config = param.config, email = param.email, emailPrefill = param.emailPrefill, requestResetPassword = param.requestResetPassword, redirectTo = param.redirectTo, maybeFetchSessionInfo = param.maybeFetchSessionInfo, loggedIn = param.loggedIn, serverLoginRedirect = param.serverLoginRedirect, updatedPassword = param.updatedPassword;
    var locale = (0,helpers_useLocale__WEBPACK_IMPORTED_MODULE_5__/* .useLocale */ .b)();
    var getSignInText = function(config) {
        var loginHeaderText;
        var registrationHeaderText;
        switch(config){
            case "resaleClosingDashboard":
                loginHeaderText = "Sign in to get back to your dashboard";
                registrationHeaderText = "Sign up to get access to your dashboard";
                break;
            default:
                break;
        }
        return {
            loginHeaderText: loginHeaderText,
            registrationHeaderText: registrationHeaderText
        };
    };
    var ref = getSignInText(config), loginHeaderText = ref.loginHeaderText, registrationHeaderText = ref.registrationHeaderText;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.register */ .co.register({
            login: js_cookie__WEBPACK_IMPORTED_MODULE_4___default().get("login-test") || "no-cookie"
        });
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.trackEvent */ .co.trackEvent("login", "load", undefined, {
            email: email,
            config: config,
            redirectTo: redirectTo,
            emailPrefill: emailPrefill
        });
        maybeFetchSessionInfo();
        redirectIfLoggedIn();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        redirectIfLoggedIn();
        if (loginRequestStatus && loginRequestStatus.error && loginRequestStatus.statusCode !== UNAUTHORIZED_STATUS_CODE) {
            var ref;
            (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, loginRequestStatus.error);
        }
    }, [
        loggedIn,
        loginRequestStatus
    ]);
    var trackLoginEvent = function(topic, label, extra) {
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.trackEvent */ .co.trackEvent("login", topic, label, extra);
    };
    var redirectIfLoggedIn = function() {
        if (loggedIn) {
            _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.trackEvent */ .co.trackEvent("login", "redirect", undefined, {
                email: email,
                config: config,
                redirectTo: redirectTo,
                serverLoginRedirect: serverLoginRedirect
            });
            var redirectUrl;
            // redirectTo="/" means "came from homepage" - not a real destination preference
            var hasClientRedirect = redirectTo && redirectTo !== "/";
            var hasServerRedirect = serverLoginRedirect && serverLoginRedirect !== "/";
            if (!hasClientRedirect && hasServerRedirect) {
                redirectUrl = serverLoginRedirect;
            } else if (hasClientRedirect) {
                // allow redirection to relative urls & opendoor.com absolute urls
                if (_globals__WEBPACK_IMPORTED_MODULE_7__/* .REDIRECT_URLS_REGEX.test */ .Ut.test(redirectTo)) {
                    // absolute path
                    redirectUrl = redirectTo;
                } else {
                    // if redirectTo does not match regex it is a relative path
                    // add `/` to enforce relative only if it does not already have one
                    redirectUrl = "".concat(redirectTo[0] === "/" ? "" : "/").concat(redirectTo);
                }
            }
            window.location.assign(redirectUrl || "/");
        }
    };
    var handlePasswordlessLoginRequest = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(email) {
            var response, errors;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        trackLoginEvent("one-time-password", "request", {
                            email: email,
                            redirectTo: redirectTo
                        });
                        return [
                            4,
                            _api__WEBPACK_IMPORTED_MODULE_6__/* .requestNewTokenByEmail */ .fs(email, redirectTo)
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response || !response.data || response.errors) {
                            errors = response && response.errors;
                            trackLoginEvent("one-time-password", "error", {
                                email: email,
                                errors: errors
                            });
                            return [
                                2,
                                {
                                    success: false,
                                    errors: errors
                                }
                            ];
                        }
                        trackLoginEvent("one-time-password", "success", {
                            email: email
                        });
                        return [
                            2,
                            {
                                success: true
                            }
                        ];
                }
            });
        });
        return function handlePasswordlessLoginRequest(email) {
            return _ref.apply(this, arguments);
        };
    }();
    var headerText = loginHeaderText;
    if (updatedPassword) {
        headerText = "Your password was successfully changed. Please sign in.";
    }
    var onRegister = function(email, name, password, phone, googleIDToken) {
        register(email, name, password, phone, googleIDToken);
        //   Do not remove - GTM event for account creation
        _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .analytics.trackEvent */ .co.trackEvent("session", "register", "account-creation", {
            email: email
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .Box */ .x, {
        py: "$24x",
        px: "$12x",
        mx: "auto",
        justifyContent: "center",
        alignItems: "center",
        $largerThanMD: {
            py: "$36x",
            px: 0
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_cinderblocks_growth_auth_LocalizationContext__WEBPACK_IMPORTED_MODULE_1__/* .LocalizationProvider */ ._, {
            locale: locale,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_cinderblocks_platform_auth_AccountForm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                analyticsName: "cosmos-account-form",
                loginHeaderText: headerText,
                registrationHeaderText: registrationHeaderText,
                email: email || emailPrefill,
                hasGeneratedPassword: hasGeneratedPassword,
                error: loginRequestStatus.error || humanStatusRequestStatus.error || registrationRequestStatus.error,
                passwordLoading: !!serverLoginRedirect || loginRequestStatus.isLoading || registrationRequestStatus.isLoading,
                emailLoading: humanStatusRequestStatus.isLoading,
                isNewHuman: isNewHuman,
                onLogin: logIn,
                overrideHasSubmittedEmailCheckForLogin: !!emailPrefill,
                onRegister: onRegister,
                onHumanStatusRequest: requestHumanStatus,
                showGoogleAuth: true,
                requestResetPassword: requestResetPassword,
                onPasswordlessLoginRequest: function(email) {
                    return handlePasswordlessLoginRequest(email);
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_shared_AccountConnector__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(AccountFormPage));


/***/ }),

/***/ 45949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15467);
/* harmony import */ var _opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5515);
/* harmony import */ var _opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29884);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42279);




var mapStateToProps = (0,reselect__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.human,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.infoIsLoaded,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.infoIsLoading,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.loggedIn,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.loginRequestStatus,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.humanStatusRequestStatus,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.registrationRequestStatus,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.serverLoginRedirect,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.email,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.hasGeneratedPassword,
    _opendoor_shared_fe_build_store_session_selectors__WEBPACK_IMPORTED_MODULE_2__.isNewHuman, 
], function(human, infoIsLoaded, infoIsLoading, loggedIn, loginRequestStatus, humanStatusRequestStatus, registrationRequestStatus, serverLoginRedirect, email, hasGeneratedPassword, isNewHuman) {
    return {
        human: human,
        infoIsLoaded: infoIsLoaded,
        infoIsLoading: infoIsLoading,
        loggedIn: loggedIn,
        loginRequestStatus: loginRequestStatus,
        humanStatusRequestStatus: humanStatusRequestStatus,
        registrationRequestStatus: registrationRequestStatus,
        serverLoginRedirect: serverLoginRedirect,
        email: email,
        hasGeneratedPassword: hasGeneratedPassword,
        isNewHuman: isNewHuman
    };
});
var mapDispatchToProps = function(dispatch) {
    return {
        maybeFetchSessionInfo: function() {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.maybeFetchSessionInfo());
        },
        maybeLogOut: function() {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.maybeLogOut());
        },
        logIn: function(email, password, googleIDToken, facebookIDToken) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.logIn(email, password, googleIDToken, facebookIDToken));
        },
        requestHumanStatus: function(email) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.requestHumanStatus(email));
        },
        requestResetPassword: function(email) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.requestPasswordReset(email));
        },
        register: function(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl) {
            dispatch(_opendoor_shared_fe_build_store_session_actions__WEBPACK_IMPORTED_MODULE_1__.register(email, name, password, phone, googleIDToken, facebookIDToken, passwordlessToken, hasGeneratedPassword, redirectUrl));
        }
    };
};
/**
 * This is an HOC that provides access to the session state via props
 *
 * @deprecated Use @opendoor/auth-fe::useAuth instead
 */ var AccountConnector = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ __webpack_exports__["Z"] = (AccountConnector);


/***/ }),

/***/ 3542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35944);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15467);
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26198);
/* harmony import */ var _opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _opendoor_shared_fe_build_sagas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2775);
/* harmony import */ var _opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95718);
/* harmony import */ var _opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4544);
/* harmony import */ var _opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21597);
/* harmony import */ var redux_immutable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72739);
/* harmony import */ var redux_saga__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87200);
/* harmony import */ var redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92242);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35480);













var sagas = function sagas() {
    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__.all)([
                        (0,redux_saga_effects__WEBPACK_IMPORTED_MODULE_8__.fork)(new (_opendoor_shared_fe_build_store_session_saga__WEBPACK_IMPORTED_MODULE_4___default())(new (_opendoor_shared_fe_build_api_session__WEBPACK_IMPORTED_MODULE_1___default())(_globals__WEBPACK_IMPORTED_MODULE_9__/* .XSRF_COOKIE_KEY */ .x0, _globals__WEBPACK_IMPORTED_MODULE_9__/* .RAILS_URL */ .oF)).saga)
                    ])
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
};
var sagaMiddleware = (0,redux_saga__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)({
    onError: _opendoor_shared_fe_build_sagas__WEBPACK_IMPORTED_MODULE_2__/* .sagaMiddlewareErrorHandler */ .e
});
var composeEnhancers = ( true && window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux__WEBPACK_IMPORTED_MODULE_5__/* .compose */ .qC;
var reducers = {
    session: (_opendoor_shared_fe_build_store_session__WEBPACK_IMPORTED_MODULE_3___default().reducer)
};
var store = (0,redux__WEBPACK_IMPORTED_MODULE_5__/* .createStore */ .MT)((0,redux_immutable__WEBPACK_IMPORTED_MODULE_6__/* .combineReducers */ .U)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, reducers)), undefined, composeEnhancers((0,redux__WEBPACK_IMPORTED_MODULE_5__/* .applyMiddleware */ .md)(sagaMiddleware)));
sagaMiddleware.run(sagas);
var ReduxWrapper = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(react_redux__WEBPACK_IMPORTED_MODULE_0__/* .Provider */ .zt, {
        store: store,
        children: props.children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReduxWrapper);


/***/ }),

/***/ 17919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useOnLoad; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// Periodically we want to load something after the window has loaded. This will
// do that, it also adds a buffer so it's definitely "afterLoad", these are for
// low-priority things.
var useOnLoad = function() {
    var onLoadStateChange = function onLoadStateChange() {
        setTimeout(function() {
            return setIsAfterLoad(true);
        }, 1000);
    };
    var handleLoadStateCleanup = function handleLoadStateCleanup() {
        window.removeEventListener("load", onLoadStateChange);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(// handle ssr
    typeof document === "undefined" ? false : document.readyState === "complete"), isAfterLoad = ref[0], setIsAfterLoad = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isAfterLoad) {
            handleLoadStateCleanup();
            return;
        }
        window.addEventListener("load", onLoadStateChange);
        return handleLoadStateCleanup;
    }, [
        isAfterLoad
    ]);
    return isAfterLoad;
};


/***/ }),

/***/ 37680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useLocale; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_helpers_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39922);
/* harmony import */ var components_shared_trackers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59431);
/* harmony import */ var _getPreferredLocale__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35374);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87687);








var useLocale = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.ENGLISH */ .l.ENGLISH), locale = ref[0], setLocale = ref[1];
    var localeCookie = js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get("locale");
    var anonId = (0,components_shared_trackers__WEBPACK_IMPORTED_MODULE_3__/* .getAnonymousId */ .y)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var loadLangPref = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
                var preferredLocale, finalLocale;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,_getPreferredLocale__WEBPACK_IMPORTED_MODULE_4__/* .determinePreferredLocale */ .B)({
                                    localeFromCookie: localeCookie,
                                    anonId: anonId
                                })
                            ];
                        case 1:
                            preferredLocale = _state.sent();
                            finalLocale = preferredLocale || components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.ENGLISH */ .l.ENGLISH;
                            setLocale(finalLocale);
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadLangPref() {
                return _ref.apply(this, arguments);
            };
        }();
        loadLangPref();
    }, [
        anonId,
        localeCookie
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        _i18n__WEBPACK_IMPORTED_MODULE_5__/* .i18n.changeLanguage */ .ag.changeLanguage(locale);
    }, [
        locale
    ]);
    return locale;
};


/***/ }),

/***/ 47398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shared_LandingPageV2Layout; },
  "getLandingpageV2ServerSideProps": function() { return /* binding */ getLandingpageV2ServerSideProps; },
  "getPreloadsFromLoaderData": function() { return /* binding */ getPreloadsFromLoaderData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/@opendoor/shared-fe/build/faviconPath.js
var faviconPath = __webpack_require__(71390);
// EXTERNAL MODULE: ./node_modules/next/dist/server/api-utils/index.js
var api_utils = __webpack_require__(38464);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/cms/index.ts + 1 modules
var cms = __webpack_require__(96887);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
// EXTERNAL MODULE: ./src/components/helpers/types.ts
var types = __webpack_require__(39922);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Toast/Toast.js + 3 modules
var Toast = __webpack_require__(64370);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/novo/components/text.mjs
var components_text = __webpack_require__(9225);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/theme/ODThemeLite.mjs
var ODThemeLite = __webpack_require__(69666);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/cms/utils.ts
var utils = __webpack_require__(46000);
;// CONCATENATED MODULE: ./src/cms/navHeaderUtils.ts


function extractNavData(header) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var mainNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref = header.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.mainNav) === null || ref1 === void 0 ? void 0 : ref1.forEach(function(link) {
        // mainNav can now be ILpElementLink (simple) or ILpElementSimpleList (with sections)
        // Only extract simple links for mainNavLinks
        if (!(0,utils/* isSimpleLink */.$)(link)) return;
        if (!link.fields.text || !link.fields.url) return;
        mainNavLinks.push({
            name: link.fields.text,
            href: link.fields.url
        });
    });
    var menuPanelNavLinks = [];
    header === null || header === void 0 ? void 0 : (ref2 = header.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.menuPanelNav) === null || ref3 === void 0 ? void 0 : ref3.forEach(function(link) {
        if (link.fields.text && link.fields.url) {
            menuPanelNavLinks.push({
                name: link.fields.text,
                href: link.fields.url
            });
        }
    });
    var ctaTitle = header === null || header === void 0 ? void 0 : header.fields.menuPanelCtaTitle;
    var ctaLink;
    if ((header === null || header === void 0 ? void 0 : (ref4 = header.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.menuPanelCta) === null || ref5 === void 0 ? void 0 : ref5.fields.text) && (header === null || header === void 0 ? void 0 : (ref6 = header.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.menuPanelCta) === null || ref7 === void 0 ? void 0 : ref7.fields.url)) {
        ctaLink = {
            name: header.fields.menuPanelCta.fields.text,
            href: header.fields.menuPanelCta.fields.url
        };
    }
    // Transform header.mainNav (union type) into MegaNavItem[] format
    var megaNavData = (0,cms/* transformHeaderNavToMegaNav */.$C)(header === null || header === void 0 ? void 0 : (ref8 = header.fields) === null || ref8 === void 0 ? void 0 : ref8.mainNav);
    return {
        mainNavLinks: mainNavLinks,
        menuPanelNavLinks: menuPanelNavLinks,
        megaNavData: megaNavData,
        ctaTitle: ctaTitle,
        ctaLink: ctaLink
    };
}

// EXTERNAL MODULE: ./src/components/shared/GlobalStyles.tsx
var GlobalStyles = __webpack_require__(54991);
// EXTERNAL MODULE: ./src/components/shared/trackers.tsx
var trackers = __webpack_require__(59431);
// EXTERNAL MODULE: ./src/helpers/getPreferredLocale.ts
var getPreferredLocale = __webpack_require__(35374);
// EXTERNAL MODULE: ./src/helpers/queryParams.ts
var queryParams = __webpack_require__(43552);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/InspectionBanner.tsx
"use client";



var GiftIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M18.5 21H5.5V12H3.5V8H20.5V12H18.5V21Z",
                fill: "url(#paint0_linear_4031_637)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M12 8V21M12 8C11.6383 6.5094 11.0154 5.23501 10.2127 4.34311C9.41003 3.45121 8.46469 2.98314 7.5 2.99995C6.83696 2.99995 6.20107 3.26334 5.73223 3.73218C5.26339 4.20102 5 4.83691 5 5.49995C5 6.16299 5.26339 6.79887 5.73223 7.26772C6.20107 7.73656 6.83696 7.99995 7.5 7.99995M12 8C12.3617 6.5094 12.9846 5.23501 13.7873 4.34311C14.59 3.45121 15.5353 2.98314 16.5 2.99995C17.163 2.99995 17.7989 3.26334 18.2678 3.73218C18.7366 4.20102 19 4.83691 19 5.49995C19 6.16299 18.7366 6.79887 18.2678 7.26772C17.7989 7.73656 17.163 7.99995 16.5 7.99995M19 12V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V12M3 9C3 8.73478 3.10536 8.48043 3.29289 8.29289C3.48043 8.10536 3.73478 8 4 8H20C20.2652 8 20.5196 8.10536 20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V11C21 11.2652 20.8946 11.5196 20.7071 11.7071C20.5196 11.8946 20.2652 12 20 12H4C3.73478 12 3.48043 11.8946 3.29289 11.7071C3.10536 11.5196 3 11.2652 3 11V9Z",
                stroke: "#F9C940",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "paint0_linear_4031_637",
                    x1: "16",
                    y1: "9",
                    x2: "12",
                    y2: "21",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            stopColor: "#A51C1C"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: "1",
                            stopColor: "#E12020"
                        })
                    ]
                })
            })
        ]
    });
};
var BANNER_DISMISSED_KEY = "inspection-banner-dismissed";
/**
 * Promotional banner for free home inspection report offer.
 * Part of experiment: growth-25-12-inspection-banner
 *
 * Impression tracking is handled at the Cloudflare Worker level.
 *
 * Figma: https://www.figma.com/design/PRkjHWTpRlrz6YFlekrChg/?node-id=4002-2104
 */ var InspectionBanner = function() {
    var ref = (0,react.useState)(true), isDismissed = ref[0], setIsDismissed = ref[1]; // Start hidden to prevent flash
    (0,react.useEffect)(function() {
        // Check localStorage on mount
        var dismissed = localStorage.getItem(BANNER_DISMISSED_KEY) === "true";
        setIsDismissed(dismissed);
    }, []);
    var handleDismiss = function() {
        setIsDismissed(true);
        localStorage.setItem(BANNER_DISMISSED_KEY, "true");
    };
    if (isDismissed) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        id: "inspection-banner",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: "$3x",
        paddingHorizontal: "$4x",
        gap: "$3x",
        // Figma: #00278b (sem/color/background/state/hover/accent-brand)
        style: {
            backgroundColor: "#00278b"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                $largerThanSM: {
                    justifyContent: "center"
                },
                gap: "$2x",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexShrink: 0,
                        display: "flex",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GiftIcon, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "white",
                        textAlign: "left",
                        $largerThanSM: {
                            textAlign: "center"
                        },
                        children: [
                            "Get a",
                            " ",
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                fontWeight: "$medium",
                                color: "white",
                                children: "FREE home inspection report"
                            }),
                            " ",
                            "($450 value) with your Opendoor offer"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                flexShrink: 0,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* CloseButton */.PZ, {
                    analyticsName: "cosmos-inspection-banner-close",
                    onPress: handleDismiss,
                    size: "small",
                    variant: "inverse"
                })
            })
        ]
    });
};
/* harmony default export */ var landing_pages_v2_InspectionBanner = (InspectionBanner);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/Header.tsx + 22 modules
var Header = __webpack_require__(71678);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/useInspectionBannerExperiment.ts


var INSPECTION_BANNER_EXPERIMENT_KEY = "growth-25-12-inspection-banner";
/**
 * LocalStorage key for storing the experiment variant.
 * This allows us to pass the variant to the backend when creating a seller input
 * so it can be stored on the lead for Iterable attribution.
 */ var INSPECTION_BANNER_VARIANT_STORAGE_KEY = "inspection-banner-experiment-variant";
/**
 * Get the stored inspection banner experiment variant from localStorage.
 * This can be used when creating a seller input to pass the variant to the backend
 * for Iterable attribution tracking.
 */ function getStoredInspectionBannerVariant() {
    if (false) {}
    var stored = localStorage.getItem(INSPECTION_BANNER_VARIANT_STORAGE_KEY);
    if (stored === "treatment" || stored === "control") {
        return stored;
    }
    return null;
}
/**
 * Hook to get the inspection banner experiment variant from query params.
 * Returns 'treatment' to show the banner, 'control' for no banner,
 * or null while loading.
 *
 * The variant is bucketed at the Cloudflare Worker level using Amplitude local evaluation
 * and passed to Cosmos via the `inspection_banner_variant` query param.
 * Impression tracking is handled automatically by the CF Worker.
 *
 * The variant is also stored in localStorage so it can be passed to the backend
 * when creating a seller input for Iterable attribution tracking.
 */ function useInspectionBannerExperiment() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), variant = ref[0], setVariant = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    (0,react.useEffect)(function() {
        // Wait for router to be ready (query params populated)
        if (!router.isReady) {
            return;
        }
        // Read variant from query param (set by Cloudflare Worker)
        var queryVariant = router.query.inspection_banner_variant;
        var resolvedVariant = queryVariant === "treatment" ? "treatment" : "control";
        setVariant(resolvedVariant);
        setIsLoading(false);
        // Store variant in localStorage for backend attribution
        localStorage.setItem(INSPECTION_BANNER_VARIANT_STORAGE_KEY, resolvedVariant);
    }, [
        router.isReady,
        router.query.inspection_banner_variant
    ]);
    return {
        variant: variant,
        isLoading: isLoading
    };
}

// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Dialog/index.js + 7 modules
var Dialog = __webpack_require__(60179);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/VisitorModal.tsx




var GetCashOfferModal = function(entry) {
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        var timer;
        if (authentication.state === "not_authenticated") {
            var hasShownDialog = localStorage.getItem("getCashOfferModalShown");
            if (!hasShownDialog) {
                timer = setTimeout(function() {
                    setIsOpen(true);
                    localStorage.setItem("getCashOfferModalShown", "true");
                }, 400);
            }
        }
        return function() {
            return clearTimeout(timer);
        };
    }, [
        authentication.state
    ]);
    var handleClose = function() {
        setIsOpen(!isOpen);
    };
    var analyticsName = "cosmos-landing-page-visitor-modal-".concat(entry === null || entry === void 0 ? void 0 : entry.analyticsId);
    var largerThanSM = (0,cjs.useMedia)().largerThanSM;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
        isOpen: isOpen,
        dismissable: largerThanSM ? true : false,
        animation: "accelerateDecelerateFast",
        setIsOpen: handleClose,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            maxWidth: 504,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                title: entry.title,
                titleProps: {
                    typography: "$subheaderLarge",
                    $largerThanSM: {
                        typography: "$headerLarge"
                    }
                },
                description: entry.description,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    $largerThanSM: {
                        pt: "$24x"
                    },
                    pt: "$16x",
                    children: [
                        !largerThanSM && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            variant: "secondary",
                            size: "small",
                            analyticsName: analyticsName,
                            label: "Close",
                            onPress: handleClose
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                            marginTop: "$4x",
                            variant: "primary",
                            size: "small",
                            $largerThanSM: {
                                size: "medium"
                            },
                            onPress: function() {
                                document.location.href = "https://www.opendoor.com/address-entry";
                            },
                            analyticsName: "".concat(analyticsName, "-cash-offer-cta"),
                            label: "Get a cash offer"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var VisitorModal = (GetCashOfferModal);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/Layout.tsx






















var MaintenanceBanner = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 716).then(__webpack_require__.bind(__webpack_require__, 40716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40716)
            ];
        }
    }
});
var Footer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1243).then(__webpack_require__.bind(__webpack_require__, 71243));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71243)
            ];
        }
    }
});
var LANGUAGE_TOAST_SEEN_KEY = "language-toast-seen";
var Layout = function(param) {
    var header = param.header, slug = param.slug, footer = param.footer, extraLegalText = param.extraLegalText, showEligibilityLegal = param.showEligibilityLegal, showCustomerTestimonialLegal = param.showCustomerTestimonialLegal, showThePdpCopyrightLegal = param.showThePdpCopyrightLegal, showPromotionLegal = param.showPromotionLegal, children = param.children, showModal = param.showModal, modalTitle = param.modalTitle, modalDescription = param.modalDescription, modalAnalyticsId = param.modalAnalyticsId, showLanguageToggle = param.showLanguageToggle;
    var ref = (0,react.useState)(false), showLanguageToast = ref[0], setShowLanguageToast = ref[1];
    var ref1 = useInspectionBannerExperiment(), inspectionBannerVariant = ref1.variant;
    // Only show inspection banner on homepage variants for treatment group
    // Matches: '/', '/homepage-kt', '/homepage-v2', '/landing-pages-v2/homepage-kt', etc.
    var isHomepage = slug === "/" || slug.toLowerCase().includes("homepage");
    var showInspectionBanner = isHomepage && inspectionBannerVariant === "treatment";
    (0,react.useEffect)(function() {
        var checkLanguagePreference = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var hasSeenLanguageToast, localeCookie, anonId, preferredLocale;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            hasSeenLanguageToast = localStorage.getItem(LANGUAGE_TOAST_SEEN_KEY) === "true";
                            if (hasSeenLanguageToast) {
                                return [
                                    2
                                ];
                            }
                            localeCookie = js_cookie_default().get("locale");
                            anonId = (0,trackers/* getAnonymousId */.y)();
                            return [
                                4,
                                (0,getPreferredLocale/* determinePreferredLocale */.B)({
                                    localeFromCookie: localeCookie,
                                    anonId: anonId
                                })
                            ];
                        case 1:
                            preferredLocale = _state.sent();
                            // show toggle for auto-defaulted users only
                            if (preferredLocale === types/* LOCALES.SPANISH */.l.SPANISH) {
                                setShowLanguageToast(true);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function checkLanguagePreference() {
                return _ref.apply(this, arguments);
            };
        }();
        checkLanguagePreference();
    }, []);
    var handleLanguageToastClose = function() {
        setShowLanguageToast(false);
        localStorage.setItem(LANGUAGE_TOAST_SEEN_KEY, "true");
    };
    var navData = extractNavData(header);
    var mainNavLinks = navData.mainNavLinks, menuPanelNavLinks = navData.menuPanelNavLinks, megaNavData = navData.megaNavData, ctaTitle = navData.ctaTitle, ctaLink = navData.ctaLink;
    var getOfferExperiment = (0,queryParams/* default */.Z)().getOfferExperiment;
    var showGetCashOfferModal = showModal && getOfferExperiment === "treatment";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ODThemeLite/* ThemedLite */.h, {
        baseTheme: "novo",
        team: "growth",
        launchDateString: new Date().toISOString(),
        // NOTE: This is a hack to fix responsive sizing due to issues in the feature's figma designs
        // TODO(@product-growth): Remove this when the design system is updated
        overrides: {
            components: {
                Text: {
                    sizes: UpdatedTextSizing
                },
                Heading: {
                    sizes: UpdatedTextSizing
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preconnect",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "dns-prefetch",
                        href: "https://images.opendoor.com"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-regular/Graphik-Regular.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-medium/Graphik-Medium.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-semibold/Graphik-Semibold.woff2",
                        as: "font"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        crossOrigin: "anonymous",
                        href: "/fonts/graphik-bold/Graphik-Bold.woff2",
                        as: "font"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GlobalStyles/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MaintenanceBanner, {}),
            showInspectionBanner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landing_pages_v2_InspectionBanner, {}),
            showGetCashOfferModal && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VisitorModal, {
                title: modalTitle,
                description: modalDescription,
                analyticsId: modalAnalyticsId
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                position: "relative",
                display: "block",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {
                        menuPanelNavLinks: menuPanelNavLinks,
                        mainNavLinks: mainNavLinks,
                        ctaTitle: ctaTitle,
                        ctaLink: ctaLink,
                        slug: slug,
                        showLanguageToggle: showLanguageToggle,
                        megaNavData: megaNavData
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("main", {
                        tabIndex: -1,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            width: "100%",
                            margin: 0,
                            display: "block",
                            children: [
                                children,
                                footer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, {
                                    footerTitle: footer.fields.footerTitle,
                                    footerNav: footer.fields.footerNav,
                                    sellInYourMarket: footer.fields.sellInYourMarket,
                                    googlePlaystoreLink: footer.fields.googlePlaystoreLink,
                                    appleStoreLink: footer.fields.appleStoreLink,
                                    helpCenterLink: footer.fields.helpCenterLink,
                                    backgroundColor: footer.fields.backgroundColor,
                                    extraLegalText: extraLegalText,
                                    showCustomerTestimonialLegal: showCustomerTestimonialLegal,
                                    showEligibilityLegal: showEligibilityLegal,
                                    showPromotionLegal: showPromotionLegal,
                                    showThePdpCopyrightLegal: showThePdpCopyrightLegal,
                                    locale: footer.sys.locale,
                                    aiPrompt: footer.fields.aiPrompt
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toast/* Toast */.F, {
                message: "No todo el contenido est\xe1 disponible en espa\xf1ol. Puedes actualizar tu preferencia de idioma en el men\xfa.",
                isOpen: showLanguageToast,
                onClose: handleLanguageToastClose,
                duration: 5000,
                analyticsName: "spanish-nofify"
            })
        ]
    });
};
/**
 * All the following typography overrides are for the 2023 Homepage Reskin project
 * https://www.figma.com/file/g2qLawddmhROv347l6EF7m/HP-Reskin?type=design&node-id=325-28241&mode=design&t=5CA6uSlmM7nuVuIC-0
 * TODO: re-assess overrides after experiment is over
 *
 * NOTE: This object gets deep merged w/ the novo theme so we only need to define the differences
 */ var UpdatedTextSizing = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, components_text/* sizes */.J), {
    100: {
        fontSize: [
            "14px",
            null,
            null,
            "18px"
        ],
        lineHeight: "140",
        letterSpacing: "-1.4"
    },
    // Used in FAQsDisplay, VideoHero, ReviewCard, MenuPanel
    110: {
        fontSize: [
            "16px",
            null,
            "14px",
            "16px"
        ],
        lineHeight: [
            "25.6px",
            null,
            "25.6px",
            "160%"
        ],
        letterSpacing: [
            "-1.4%",
            "-0.014em",
            "-0.014em",
            "-0.018em"
        ]
    },
    // Used in Hero, ReviewCard
    120: {
        fontSize: "18px",
        lineHeight: "120",
        letterSpacing: "-2.4"
    },
    // Used in StickyCTAUtility
    130: {
        fontSize: [
            "16px",
            null,
            "19px"
        ],
        lineHeight: "19px",
        letterSpacing: "-2.4"
    },
    // Used in Footer, Hero
    140: {
        fontSize: "22px",
        lineHeight: "112",
        letterSpacing: "-2.4"
    },
    // Used in FAQsDisplay, MapBackgroundHero, Steps, Testimonials, TextSection
    150: {
        fontSize: [
            "16px",
            null,
            null,
            "24px"
        ],
        lineHeight: [
            "130%",
            null,
            null,
            "112%"
        ],
        letterSpacing: [
            "-0.014em",
            null,
            null,
            "-0.028em"
        ]
    },
    // Used in HeroCard, VideoHero
    160: {
        fontSize: [
            "18px",
            "19px",
            null,
            "28px"
        ],
        lineHeight: [
            "120%",
            null,
            null,
            "110%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.02em",
            "-0.028em",
            "-0.028em"
        ]
    },
    // Used in CarouselCards, Footer
    170: {
        fontSize: [
            "32px",
            "36px",
            "44px",
            "56px"
        ],
        lineHeight: [
            "35.2px",
            "36px",
            "44px",
            "56px"
        ],
        letterSpacing: [
            "-2.8",
            "-3",
            "-3.4"
        ],
        fontWeight: 500
    },
    // Used in ImageCard
    180: {
        fontSize: [
            "16px",
            "18px",
            null,
            "28px"
        ],
        lineHeight: [
            "120%",
            null,
            null,
            "110%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.02em",
            "-0.028em",
            "-0.028em"
        ]
    },
    // Used in HeroCard, ImageCard
    220: {
        fontSize: [
            "22.2px",
            "28px",
            "36px",
            "56px"
        ],
        lineHeight: [
            "106%",
            "110%",
            "100%"
        ],
        letterSpacing: [
            "-0.024em",
            "-0.028em",
            "-0.03em",
            "-0.034em;"
        ]
    },
    // Used in FAQsDisplay, MapBackgroundHero, TextSection
    230: {
        fontSize: [
            "32px",
            "36px",
            "44px",
            "64px"
        ],
        lineHeight: [
            "110%",
            "100%"
        ],
        letterSpacing: [
            "-0.028em",
            "-0.03em",
            "-0.03em",
            "-0.034em;"
        ]
    },
    240: {
        fontSize: [
            "36px",
            null,
            "80px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    },
    250: {
        fontSize: [
            "44px",
            null,
            "88px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    },
    260: {
        fontSize: [
            "60px",
            null,
            "96px"
        ],
        lineHeight: "100",
        letterSpacing: "-3.4"
    }
});
/* harmony default export */ var landing_pages_v2_Layout = (Layout);

// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(77997);
// EXTERNAL MODULE: ./src/components/shared/useOnLoad.ts
var useOnLoad = __webpack_require__(17919);
;// CONCATENATED MODULE: ./src/components/shared/usePromptGoogleOneTap.ts




/**
 * Prompt the user to sign in with Google One Tap with built in error tracking + analytics
 * @param page - The page name to use for analytics tracking
 */ var usePromptGoogleOneTap = function(page, onSuccess, disablePromptGoogleOneTap, delay) {
    var ref = (0,observability/* useObservability */.C3)(), trackEvent = ref.trackEvent, trackError = ref.trackError;
    var ref1 = (0,auth_fe_esm/* useAuth */.aC)(), authentication = ref1.authentication, refresh = ref1.refresh;
    var isAfterLoad = (0,useOnLoad/* useOnLoad */.g)();
    (0,react.useEffect)(function() {
        // don't fire off the import until the document is finished loading
        if (authentication.state !== "not_authenticated" || !isAfterLoad || disablePromptGoogleOneTap) {
            return;
        }
        var prompt = function() {
            __webpack_require__.e(/* import() */ 1878).then(__webpack_require__.bind(__webpack_require__, 91878)).then(function(param) {
                var promptGoogleOneTap = param.promptGoogleOneTap;
                promptGoogleOneTap("cosmos-".concat(page), function(redirectTo) {
                    onSuccess && onSuccess();
                    if (redirectTo) {
                        window.location.assign(redirectTo);
                    } else {
                        refresh();
                    }
                }, trackEvent, trackError);
            });
        };
        var timer;
        if (delay) {
            timer = setTimeout(prompt, delay);
        } else {
            prompt();
        }
        return function() {
            clearTimeout(timer);
        };
    }, [
        authentication.state,
        isAfterLoad,
        delay
    ]);
};

// EXTERNAL MODULE: ./src/helpers/useLocale.ts
var useLocale = __webpack_require__(37680);
;// CONCATENATED MODULE: ./src/schema/index.ts
var HOMEPAGE_SCHEMA = {
    "@context": "http://schema.org",
    "@type": "Organization",
    legalName: "Opendoor Labs, Inc.",
    alternateName: "Opendoor",
    url: "https://www.opendoor.com",
    contactPoint: {
        "@type": "ContactPoint",
        telephone: "+1-888-352-7075",
        contactType: "Customer Service"
    },
    address: {
        "@type": "PostalAddress",
        addressLocality: "San Francisco",
        addressCountry: "USA",
        postalCode: "94104",
        streetAddress: "1 Post St, Fl 11"
    },
    logo: "https://www.opendoor.com/w/wp-content/uploads/2019/04/Opendoor-Logo.jpg",
    sameAs: [
        "https://www.facebook.com/OpendoorHQ",
        "https://twitter.com/opendoor",
        "https://www.youtube.com/channel/UCKKVV4bx18EtclsdNOFzWBw",
        "https://www.linkedin.com/company/opendoor-com",
        "https://www.pinterest.com/opendoorhq",
        "https://en.wikipedia.org/wiki/Opendoor", 
    ]
};


;// CONCATENATED MODULE: ./src/pages/shared/LandingPageV2Layout.tsx
















var getSeoBaseTags = function(fields) {
    var title = fields === null || fields === void 0 ? void 0 : fields.title;
    var metaDescription = fields === null || fields === void 0 ? void 0 : fields.metaDescription;
    var canonicalUrl = fields === null || fields === void 0 ? void 0 : fields.canonicalUrl;
    var robots = [];
    // only set these when they are explicitly set to false
    // otherwise assume indexing and follow should be allowed
    if ((fields === null || fields === void 0 ? void 0 : fields.index) === false) {
        robots.push("noindex");
    }
    if ((fields === null || fields === void 0 ? void 0 : fields.follow) === false) {
        robots.push("nofollow");
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: title !== null && title !== void 0 ? title : "Opendoor | Sell your home the minute you’re ready."
            }, "title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "shortcut icon",
                href: (0,faviconPath/* default */.Z)({
                    railsEnv: globals/* DEPLOY_ENV */.Zp
                }),
                type: "image/png"
            }),
            metaDescription ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: metaDescription
            }, "description") : null,
            canonicalUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robots.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "robots",
                content: robots.join(",")
            }, "robots") : null
        ]
    });
};
var getOpenGraphTags = function(openGraphFields) {
    var url = openGraphFields.url, type = openGraphFields.type, title = openGraphFields.title, description = openGraphFields.description, image = openGraphFields.image, siteName = openGraphFields.siteName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:type",
                content: type
            }, "og:type"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:url",
                content: url
            }, "og:url"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:image",
                content: image
            }, "og:image"),
            ",",
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                property: "og:site_name",
                content: siteName
            }, "og:site_name")
        ]
    });
};
// when a no-code landing page needs to preload an image for performance reasons,
// it can include a `preloadImages` field in the loader data
// this function crunches the loader data and pulls out all the preload images
// so that the top-level page can include those preload urls in the Head section
var getPreloadsFromLoaderData = function(idToLoaderData) {
    return Object.values(idToLoaderData).map(function(loaderData) {
        return loaderData === null || loaderData === void 0 ? void 0 : loaderData.preloadImages;
    }).filter(function(preload) {
        return preload;
    }).flat();
};
var getLandingpageV2ServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        var ref, pageNum, slug, cookieParser, localeFromCookie, locale, props, showModal, excludedSlugs, modalProps, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!((ref = context.params) === null || ref === void 0 ? void 0 : ref.slug)) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    pageNum = 1;
                    if (context.query.page) {
                        pageNum = parseInt(context.query.page);
                    }
                    if (pageNum < 1) pageNum = 1;
                    slug = "";
                    // if slug is a string and not an array
                    if (typeof context.query.slug === "string") {
                        slug = context.query.slug;
                    } else if (Array.isArray(context.query.slug)) {
                        slug = context.query.slug.join("/");
                    }
                    cookieParser = (0,api_utils/* getCookieParser */.ac)(context.req.headers);
                    localeFromCookie = cookieParser().locale;
                    locale = localeFromCookie === types/* LOCALES.SPANISH */.l.SPANISH ? types/* LOCALES.SPANISH */.l.SPANISH : types/* LOCALES.ENGLISH */.l.ENGLISH;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        (0,cms/* fetchLandingPageV2BySlug */.AL)({
                            slug: slug,
                            requestUrl: context.resolvedUrl,
                            pageNum: pageNum,
                            locale: locale
                        })
                    ];
                case 2:
                    props = _state.sent();
                    if (!props) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    // check if the page is set to public, and reject if appropriate
                    // this is intended to block non-public pages from being directly accessed by users,
                    // while still letting them be used in experiments as treatments
                    if (context.query.public && props.public === false) {
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    showModal = false;
                    excludedSlugs = [
                        "builder",
                        "agent",
                        "real-estate",
                        "homepage",
                        "login",
                        "register",
                        "reset-password",
                        "calculator",
                        "careers",
                        "safety",
                        "privacy"
                    ];
                    if (!excludedSlugs.every(function(excluded) {
                        return !slug.includes(excluded);
                    })) return [
                        3,
                        4
                    ];
                    showModal = true;
                    return [
                        4,
                        (0,cms/* getCashOfferModal */.Mq)()
                    ];
                case 3:
                    modalProps = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        {
                            props: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                                modalFields: showModal && modalProps ? {
                                    title: modalProps.fields.title,
                                    description: modalProps.fields.description,
                                    analyticsId: modalProps.fields.analyticsId
                                } : null,
                                showModal: !!(showModal && modalProps)
                            })
                        }
                    ];
                case 5:
                    e = _state.sent();
                    // eslint-disable-next-line no-console
                    console.error(e);
                    return [
                        2,
                        {
                            notFound: true
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function getLandingpageV2ServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var LandingPageV2Layout = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    usePromptGoogleOneTap("landing-pages-v2-".concat(props.fields.slug), undefined, props.hideGoogleOneTap);
    (0,useLocale/* useLocale */.b)();
    var contextualData = {
        landingPageSlug: props.fields.slug
    };
    var imagePreloads = getPreloadsFromLoaderData(props.idToLoaderData);
    var openGraphFields = (ref = props.fields.openGraph) === null || ref === void 0 ? void 0 : ref.fields;
    var appleStatusBarColor = props.fields.slug === "homepage-syw-v2-home-guide" ? "black" : "default";
    var shouldIncludeTrustpilot = (ref1 = props.fields) === null || ref1 === void 0 ? void 0 : ref1.shouldShowTrustpilotReviews;
    // Check if this is a market page (slug format: landing-pages-v2/market-[market])
    var isMarketPage = props.fields.slug.startsWith("landing-pages-v2/market-");
    // Convert Contentful slug to public URL format for markdown alternate link
    var publicSlug = isMarketPage ? props.fields.slug.replace(/^landing-pages-v2\/market-/, "/sell/") : null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(observability_slim/* AddContextualData */.up, {
        data: contextualData,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    getSeoBaseTags((ref2 = props.fields.seoBase) === null || ref2 === void 0 ? void 0 : ref2.fields),
                    openGraphFields && getOpenGraphTags(openGraphFields),
                    isMarketPage && publicSlug && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        id: "markdown-alternate",
                        rel: "alternate",
                        type: "text/markdown",
                        href: "".concat(publicSlug, ".md")
                    }, "markdown-alternate"),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "apple-mobile-web-app-status-bar-style",
                        content: appleStatusBarColor
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(HOMEPAGE_SCHEMA)
                        }
                    }),
                    props.fields.jsonLdSchema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(props.fields.jsonLdSchema).replace(/</g, "\\u003c")
                        }
                    }),
                    shouldIncludeTrustpilot && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                        type: "text/javascript",
                        src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
                        async: true
                    }),
                    imagePreloads.map(function(h) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                            rel: "preload",
                            as: "image",
                            media: h.media,
                            // @ts-expect-error: react incorrectly capitalizes this if you use
                            // the "typescript" suggestion of `imgSrcSet`
                            imagesrcset: h.srcSet,
                            fetchpriority: "high"
                        }, h.key);
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                        rel: "preload",
                        as: "image",
                        href: "https://images.opendoor.com/source/s3/imgdrop-production/2023-08-1692902240043-86611.jpg?preset=square-512"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landing_pages_v2_Layout, {
                header: (ref3 = props.fields) === null || ref3 === void 0 ? void 0 : ref3.header,
                slug: "/".concat((ref4 = props.fields) === null || ref4 === void 0 ? void 0 : ref4.slug),
                footer: (ref5 = props.fields) === null || ref5 === void 0 ? void 0 : ref5.footer,
                showModal: props.showModal,
                modalTitle: (ref6 = props.modalFields) === null || ref6 === void 0 ? void 0 : ref6.title,
                modalDescription: (ref7 = props.modalFields) === null || ref7 === void 0 ? void 0 : ref7.description,
                modalAnalyticsId: (ref8 = props.modalFields) === null || ref8 === void 0 ? void 0 : ref8.analyticsId,
                extraLegalText: (ref9 = props.fields) === null || ref9 === void 0 ? void 0 : ref9.extraLegalText,
                showEligibilityLegal: (ref10 = props.fields) === null || ref10 === void 0 ? void 0 : ref10.showEligibilityLegal,
                showCustomerTestimonialLegal: (ref11 = props.fields) === null || ref11 === void 0 ? void 0 : ref11.showCustomerTestimonialLegal,
                showThePdpCopyrightLegal: (ref12 = props.fields) === null || ref12 === void 0 ? void 0 : ref12.showThePdpCopyrightLegal,
                showPromotionLegal: (ref13 = props.fields) === null || ref13 === void 0 ? void 0 : ref13.showPromotionLegal,
                showLanguageToggle: (ref14 = props.fields) === null || ref14 === void 0 ? void 0 : ref14.showLanguageToggle,
                children: props.children
            })
        ]
    });
};
/* harmony default export */ var shared_LandingPageV2Layout = (LandingPageV2Layout);


/***/ }),

/***/ 24773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ LocalizationProvider; }
/* harmony export */ });
/* unused harmony export useLocalization */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77601);
/* harmony import */ var core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_test_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var _i18n_index_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56978);













function cov_1x2xuaq99b() {
    var path = "/__w/code/code/js/packages/cinderblocks/src/growth/auth/LocalizationContext.tsx";
    var hash = "31c57441b2debfd5092b25a97ab88aa07e203228";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/__w/code/code/js/packages/cinderblocks/src/growth/auth/LocalizationContext.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 11,
                    column: 28
                },
                end: {
                    line: 14,
                    column: 2
                }
            },
            "1": {
                start: {
                    line: 16,
                    column: 85
                },
                end: {
                    line: 38,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 20,
                    column: 28
                },
                end: {
                    line: 20,
                    column: 62
                }
            },
            "3": {
                start: {
                    line: 22,
                    column: 2
                },
                end: {
                    line: 29,
                    column: 15
                }
            },
            "4": {
                start: {
                    line: 23,
                    column: 4
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            "5": {
                start: {
                    line: 24,
                    column: 6
                },
                end: {
                    line: 24,
                    column: 22
                }
            },
            "6": {
                start: {
                    line: 25,
                    column: 6
                },
                end: {
                    line: 25,
                    column: 61
                }
            },
            "7": {
                start: {
                    line: 25,
                    column: 45
                },
                end: {
                    line: 25,
                    column: 59
                }
            },
            "8": {
                start: {
                    line: 27,
                    column: 6
                },
                end: {
                    line: 27,
                    column: 21
                }
            },
            "9": {
                start: {
                    line: 31,
                    column: 2
                },
                end: {
                    line: 31,
                    column: 26
                }
            },
            "10": {
                start: {
                    line: 31,
                    column: 14
                },
                end: {
                    line: 31,
                    column: 26
                }
            },
            "11": {
                start: {
                    line: 33,
                    column: 2
                },
                end: {
                    line: 37,
                    column: 4
                }
            },
            "12": {
                start: {
                    line: 40,
                    column: 31
                },
                end: {
                    line: 40,
                    column: 68
                }
            },
            "13": {
                start: {
                    line: 40,
                    column: 37
                },
                end: {
                    line: 40,
                    column: 68
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 16,
                        column: 85
                    },
                    end: {
                        line: 16,
                        column: 86
                    }
                },
                loc: {
                    start: {
                        line: 19,
                        column: 6
                    },
                    end: {
                        line: 38,
                        column: 1
                    }
                },
                line: 19
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 22,
                        column: 12
                    },
                    end: {
                        line: 22,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 18
                    },
                    end: {
                        line: 29,
                        column: 3
                    }
                },
                line: 22
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 25,
                        column: 39
                    },
                    end: {
                        line: 25,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 25,
                        column: 45
                    },
                    end: {
                        line: 25,
                        column: 59
                    }
                },
                line: 25
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 40,
                        column: 31
                    },
                    end: {
                        line: 40,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 40,
                        column: 37
                    },
                    end: {
                        line: 40,
                        column: 68
                    }
                },
                line: 40
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 23,
                        column: 4
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 23,
                            column: 4
                        },
                        end: {
                            line: 28,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 26,
                            column: 11
                        },
                        end: {
                            line: 28,
                            column: 5
                        }
                    }
                ],
                line: 23
            },
            "1": {
                loc: {
                    start: {
                        line: 31,
                        column: 2
                    },
                    end: {
                        line: 31,
                        column: 26
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 31,
                            column: 2
                        },
                        end: {
                            line: 31,
                            column: 26
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 31
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "31c57441b2debfd5092b25a97ab88aa07e203228"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_1x2xuaq99b = function cov_1x2xuaq99b() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1x2xuaq99b();
function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}


var LocalizationContext = (cov_1x2xuaq99b().s[0]++, /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_13__.createContext)({
    locale: "en-US",
    ready: false
}));
cov_1x2xuaq99b().s[1]++;
var LocalizationProvider = function LocalizationProvider(_ref) {
    var locale = _ref.locale, children = _ref.children;
    cov_1x2xuaq99b().f[0]++;
    var _ref2 = (cov_1x2xuaq99b().s[2]++, (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(_i18n_index_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"].language */ .Z.language === locale)), _ref3 = _slicedToArray(_ref2, 2), ready = _ref3[0], setReady = _ref3[1];
    cov_1x2xuaq99b().s[3]++;
    (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function() {
        cov_1x2xuaq99b().f[1]++;
        cov_1x2xuaq99b().s[4]++;
        if (_i18n_index_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"].language */ .Z.language !== locale) {
            cov_1x2xuaq99b().b[0][0]++;
            cov_1x2xuaq99b().s[5]++;
            setReady(false);
            cov_1x2xuaq99b().s[6]++;
            _i18n_index_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"].changeLanguage */ .Z.changeLanguage(locale).then(function() {
                cov_1x2xuaq99b().f[2]++;
                cov_1x2xuaq99b().s[7]++;
                return setReady(true);
            });
        } else {
            cov_1x2xuaq99b().b[0][1]++;
            cov_1x2xuaq99b().s[8]++;
            setReady(true);
        }
    }, [
        locale
    ]);
    cov_1x2xuaq99b().s[9]++;
    if (!ready) {
        cov_1x2xuaq99b().b[1][0]++;
        cov_1x2xuaq99b().s[10]++;
        return null;
    } else {
        cov_1x2xuaq99b().b[1][1]++;
    }
    cov_1x2xuaq99b().s[11]++;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_13__.createElement(LocalizationContext.Provider, {
        value: {
            locale: locale,
            ready: ready
        }
    }, children);
};
cov_1x2xuaq99b().s[12]++;
var useLocalization = function useLocalization() {
    cov_1x2xuaq99b().f[3]++;
    cov_1x2xuaq99b().s[13]++;
    return useContext(LocalizationContext);
}; //# sourceMappingURL=LocalizationContext.mjs.map


/***/ }),

/***/ 82717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RightArrow_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2888);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var SvgRightArrow = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M11.116 4.116a1.25 1.25 0 0 1 1.768 0l7 7a1.25 1.25 0 0 1 0 1.768l-7 7a1.25 1.25 0 0 1-1.768-1.768l4.866-4.866H5a1.25 1.25 0 1 1 0-2.5h10.982l-4.866-4.866a1.25 1.25 0 0 1 0-1.768",
            clipRule: "evenodd"
        })
    }));
};
var RightArrow_default = SvgRightArrow;



/***/ }),

/***/ 6967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Row = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        flexDirection: "row"
    }, props));
});



/***/ }),

/***/ 20738:
/***/ (function(module) {

var __dirname = "/";
(()=>{"use strict";if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var e={};(()=>{var r=e;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */r.parse=parse;r.serialize=serialize;var i=decodeURIComponent;var t=encodeURIComponent;var a=/; */;var n=/^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;function parse(e,r){if(typeof e!=="string"){throw new TypeError("argument str must be a string")}var t={};var n=r||{};var o=e.split(a);var s=n.decode||i;for(var p=0;p<o.length;p++){var f=o[p];var u=f.indexOf("=");if(u<0){continue}var v=f.substr(0,u).trim();var c=f.substr(++u,f.length).trim();if('"'==c[0]){c=c.slice(1,-1)}if(undefined==t[v]){t[v]=tryDecode(c,s)}}return t}function serialize(e,r,i){var a=i||{};var o=a.encode||t;if(typeof o!=="function"){throw new TypeError("option encode is invalid")}if(!n.test(e)){throw new TypeError("argument name is invalid")}var s=o(r);if(s&&!n.test(s)){throw new TypeError("argument val is invalid")}var p=e+"="+s;if(null!=a.maxAge){var f=a.maxAge-0;if(isNaN(f)||!isFinite(f)){throw new TypeError("option maxAge is invalid")}p+="; Max-Age="+Math.floor(f)}if(a.domain){if(!n.test(a.domain)){throw new TypeError("option domain is invalid")}p+="; Domain="+a.domain}if(a.path){if(!n.test(a.path)){throw new TypeError("option path is invalid")}p+="; Path="+a.path}if(a.expires){if(typeof a.expires.toUTCString!=="function"){throw new TypeError("option expires is invalid")}p+="; Expires="+a.expires.toUTCString()}if(a.httpOnly){p+="; HttpOnly"}if(a.secure){p+="; Secure"}if(a.sameSite){var u=typeof a.sameSite==="string"?a.sameSite.toLowerCase():a.sameSite;switch(u){case true:p+="; SameSite=Strict";break;case"lax":p+="; SameSite=Lax";break;case"strict":p+="; SameSite=Strict";break;case"none":p+="; SameSite=None";break;default:throw new TypeError("option sameSite is invalid")}}return p}function tryDecode(e,r){try{return r(e)}catch(r){return e}}})();module.exports=e})();

/***/ }),

/***/ 38464:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.ac = getCookieParser;
__webpack_unused_export__ = sendStatusCode;
__webpack_unused_export__ = redirect;
__webpack_unused_export__ = checkIsManualRevalidate;
__webpack_unused_export__ = clearPreviewData;
__webpack_unused_export__ = sendError;
__webpack_unused_export__ = setLazyProp;
__webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
function getCookieParser(headers) {
    return function parseCookie() {
        const header = headers.cookie;
        if (!header) {
            return {};
        }
        const { parse: parseCookieFn  } = __webpack_require__(20738);
        return parseCookieFn(Array.isArray(header) ? header.join(";") : header);
    };
}
function sendStatusCode(res, statusCode) {
    res.statusCode = statusCode;
    return res;
}
function redirect(res, statusOrUrl, url) {
    if (typeof statusOrUrl === "string") {
        url = statusOrUrl;
        statusOrUrl = 307;
    }
    if (typeof statusOrUrl !== "number" || typeof url !== "string") {
        throw new Error(`Invalid redirect arguments. Please use a single argument URL, e.g. res.redirect('/destination') or use a status code and URL, e.g. res.redirect(307, '/destination').`);
    }
    res.writeHead(statusOrUrl, {
        Location: url
    });
    res.write(url);
    res.end();
    return res;
}
const PRERENDER_REVALIDATE_HEADER = "x-prerender-revalidate";
__webpack_unused_export__ = PRERENDER_REVALIDATE_HEADER;
const PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER = "x-prerender-revalidate-if-generated";
__webpack_unused_export__ = PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER;
function checkIsManualRevalidate(req, previewProps) {
    return {
        isManualRevalidate: req.headers[PRERENDER_REVALIDATE_HEADER] === previewProps.previewModeId,
        revalidateOnlyGenerated: !!req.headers[PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER]
    };
}
const COOKIE_NAME_PRERENDER_BYPASS = `__prerender_bypass`;
__webpack_unused_export__ = COOKIE_NAME_PRERENDER_BYPASS;
const COOKIE_NAME_PRERENDER_DATA = `__next_preview_data`;
__webpack_unused_export__ = COOKIE_NAME_PRERENDER_DATA;
const RESPONSE_LIMIT_DEFAULT = 4 * 1024 * 1024;
__webpack_unused_export__ = RESPONSE_LIMIT_DEFAULT;
const SYMBOL_PREVIEW_DATA = Symbol(COOKIE_NAME_PRERENDER_DATA);
__webpack_unused_export__ = SYMBOL_PREVIEW_DATA;
const SYMBOL_CLEARED_COOKIES = Symbol(COOKIE_NAME_PRERENDER_BYPASS);
__webpack_unused_export__ = SYMBOL_CLEARED_COOKIES;
function clearPreviewData(res, options = {}) {
    if (SYMBOL_CLEARED_COOKIES in res) {
        return res;
    }
    const { serialize  } = __webpack_require__(20738);
    const previous = res.getHeader("Set-Cookie");
    res.setHeader(`Set-Cookie`, [
        ...typeof previous === "string" ? [
            previous
        ] : Array.isArray(previous) ? previous : [],
        serialize(COOKIE_NAME_PRERENDER_BYPASS, "", {
            // To delete a cookie, set `expires` to a date in the past:
            // https://tools.ietf.org/html/rfc6265#section-4.1.1
            // `Max-Age: 0` is not valid, thus ignored, and the cookie is persisted.
            expires: new Date(0),
            httpOnly: true,
            sameSite:  true ? "none" : 0,
            secure: "production" !== "development",
            path: "/",
            ...options.path !== undefined ? {
                path: options.path
            } : undefined
        }),
        serialize(COOKIE_NAME_PRERENDER_DATA, "", {
            // To delete a cookie, set `expires` to a date in the past:
            // https://tools.ietf.org/html/rfc6265#section-4.1.1
            // `Max-Age: 0` is not valid, thus ignored, and the cookie is persisted.
            expires: new Date(0),
            httpOnly: true,
            sameSite:  true ? "none" : 0,
            secure: "production" !== "development",
            path: "/",
            ...options.path !== undefined ? {
                path: options.path
            } : undefined
        }), 
    ]);
    Object.defineProperty(res, SYMBOL_CLEARED_COOKIES, {
        value: true,
        enumerable: false
    });
    return res;
}
class ApiError extends Error {
    constructor(statusCode, message){
        super(message);
        this.statusCode = statusCode;
    }
}
__webpack_unused_export__ = ApiError;
function sendError(res, statusCode, message) {
    res.statusCode = statusCode;
    res.statusMessage = message;
    res.end(message);
}
function setLazyProp({ req  }, prop, getter) {
    const opts = {
        configurable: true,
        enumerable: true
    };
    const optsReset = {
        ...opts,
        writable: true
    };
    Object.defineProperty(req, prop, {
        ...opts,
        get: ()=>{
            const value = getter();
            // we set the property on the object to avoid recalculating it
            Object.defineProperty(req, prop, {
                ...optsReset,
                value
            });
            return value;
        },
        set: (value)=>{
            Object.defineProperty(req, prop, {
                ...optsReset,
                value
            });
        }
    });
}

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 71390:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var railsEnv_1 = __webpack_require__(27825);
var faviconPath = function (_a) {
    var _b = _a === void 0 ? {} : _a, admin = _b.admin, railsEnv = _b.railsEnv;
    var env = railsEnv || (0, railsEnv_1.getRailsEnv)();
    // these favicons created in this Figma document
    // https://www.figma.com/file/R2a9eL6fEQMq24CY2Q8752NB/Favicons?node-id=19%3A29
    if (admin) {
        if (env === 'development') {
            return 'https://imgdrop.imgix.net/1bd03e41b990465e93d1c5b90ba36c16.png';
        }
        else if (env === 'staging') {
            return 'https://imgdrop.imgix.net/a8dddd737aeb4780bf9e8edfa8bdc27b.png';
        }
        else if (env === 'qa') {
            return 'https://imgdrop.imgix.net/28c43a220c9247f1ba3764c6aa7f67b3.png';
        }
        return 'https://imgdrop.imgix.net/6f05fac182304e3d821592580acf3a68.png';
    }
    if (env === 'development') {
        return 'https://imgdrop.imgix.net/4ec068f491b4478293d83b56911a2f65.png';
    }
    else if (env === 'staging') {
        return 'https://imgdrop.imgix.net/006a1ec0195a4e95bea9bd906d99130c.png';
    }
    else if (env === 'qa') {
        return 'https://imgdrop.imgix.net/5618f1f758be4937861351a1c96548d6.png';
    }
    return 'https://imgdrop.imgix.net/cf88fd37a91e43b0b7aafe6b076d2810.png';
};
exports.Z = faviconPath;


/***/ })

}]);